if (typeof VideoHero !== 'function') {
  class VideoHero extends HTMLElement {
    constructor() {
      super();

      this.innerContainer = this.querySelector('[data-js-video-hero-container]');
      this.querySelector('[data-js-video-hero-link]').addEventListener('click', (e) => {
        e.preventDefault();

        const blackout = document.createElement('div');
        blackout.classList.add('video-hero__blackout');
        this.innerContainer.append(blackout);
        setTimeout(() => {
          blackout.style.opacity = '1';
        }, 10);

        this.classList.add('video-opened');

        if (this.querySelector('[data-js-video-hero-close]')) {
          this.querySelector('[data-js-video-hero-close]').addEventListener('click', (e) => {
            this.querySelectorAll('iframe, video').forEach((elm) => {
              elm.remove();
            });
            blackout.remove();
            this.classList.remove('video-opened');
          });
        }

        setTimeout(() => {
          this.innerContainer.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
          setTimeout(() => {
            this._playMedia(this.closest('[data-video]'));
          }, 500);
        }, 50);
      });
    }

    _playMedia(media) {
      switch (media.dataset.productMediaType) {
        case 'video':
          if (media.querySelector('video')) {
            media.querySelector('video').play();
          }
          break;
        case 'external_video-youtube':
          if (media.querySelector('.js-youtube')) {
            media
              .querySelector('.js-youtube')
              .contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
          }
          break;
        case 'external_video-vimeo':
          if (media.querySelector('.js-vimeo')) {
            media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
          }
          break;
      }
    }
  }

  if (typeof customElements.get('video-hero') == 'undefined') {
    customElements.define('video-hero', VideoHero);
  }
}
